import React from "react";
import { Routes, Route } from "react-router-dom";

import { authRoutes } from "../shared/routes/configs/authRoutes";

const AuthLayout = () => {
  return (
    <div>
      <Routes>
        {authRoutes.map((route) => {
          const path =
            route.path === "/"
              ? ""
              : route.path.startsWith("/")
                ? route.path.substring(1)
                : route.path;
          return <Route path={path} element={route.element} key={route.path} />;
        })}
      </Routes>
    </div>
  );
};

export default AuthLayout;
